import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from '@fluentui/react-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

import MicrosoftBrandingIMG from '../media/microsoft-branding.png';
import { getLandingPageHeaderStyles } from './landing-page-header-styles';

export function LandingPageHeader(props) {
  const {
    onClickLogIn,
    onClickSignUp,
  } = props;

  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const classes = useDefaultStyles(getLandingPageHeaderStyles);
  const i18n = useContext(I18nContext);

  return (
    <div className={classNames('landing-page-header', classes.container)} role="banner">
      <div className={classNames(classes.innerContainer, classes[`innerContainer-${displayMode}`])}>
        <div className={classes.brandContainer}>
          <img
            src={MicrosoftBrandingIMG}
            alt={i18n.getString(_TL_('Microsoft Advertising'))}
            className="brand-img"
          />
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            className={classNames('login-button', classes.loginButton, classes[`button-${displayMode}`])}
            onClick={onClickLogIn}
          >
            {i18n.getString(_TL_('Log in'))}
          </Button>
          <Button
            className={classNames('signup-button', classes.signUpButton, classes[`button-${displayMode}`])}
            onClick={onClickSignUp}
            appearance="primary"
          >
            {i18n.getString(_TL_('Sign up'))}
          </Button>
        </div>
      </div>
    </div>
  );
}

LandingPageHeader.propTypes = {
  onClickSignUp: PropTypes.func.isRequired,
  onClickLogIn: PropTypes.func.isRequired,
};
